import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class KanbanBoardPropsBuilder extends PropsBuilder<'kanbanBoard'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { background: { visualEffect } } });
    return this;
  };

  constructor(props: PartialPropsOf<'kanbanBoard'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
